import React from "react";
import "./HowWorkSection.css";

import workImage1 from "../Assets/images/start.jpg";
import workImage2 from "../Assets/images/waterproject.jpg";

const HowWorkSection = () => {

  const handleActNowClick = () => {
    const registrationSection = document.getElementById("registration-section");
    if (registrationSection) {
      // Adjust for fixed navbar height (example: 220px)
      const yOffset = -90;
      const y = registrationSection.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <section className="howwork">
      <div className="howwork-container">

        {/* Left column - Images */}
        <div className="howwork-images">
          <img src={workImage1} alt="Ripple Run Participants" className="top-image" />
          <img src={workImage2} alt="Community Engagement" className="bottom-image" />
        </div>

        {/* Right column - Text */}
        <div className="howwork-content">
          <h2>How Does It Work?</h2>

          <p>
            Ripple Run is an annual event that gathers people from all walks of life
            to participate in a run for a cause. It's an opportunity to make a
            difference by supporting health, wellness, clean water, children, and
            future generations in Ghana. Join us in creating a ripple of positive
            impact.
          </p>

          <button
            className="howwork-button"
            onClick={handleActNowClick} // <-- Scroll to registration
          >
            Act Now
          </button>

          <p className="highlight-text">
            In many communities, children, especially girls, spend hours fetching water.<br /><br />
            That’s lost education.<br />
            Lost opportunity.<br />
            Lost potential.
          </p>

          <p className="highlight-text">
            Contaminated water contributes to:<br /><br />
            Cholera outbreaks<br />
            Typhoid<br />
            Diarrheal diseases<br /><br />
            Clean water isn’t luxury.<br />
            It’s life-saving infrastructure.
          </p>
        </div>

      </div>
    </section>
  );
};

export default HowWorkSection;